import React, {useRef, useEffect, useState} from 'react';
import {Message} from './message';
import {Input} from '@material-ui/core';
import Button from '../custom-button';
import './panel.scss';
import {List} from 'immutable';
import {ChatMessage} from '../../utils/types';
import {useRoomState} from '../../containers/root-container';
import useChatControl from '../../hooks/use-chat-control';
import {sfAjax} from "../../utils/custom_api";

interface ChatPanelProps {
    messages: List<ChatMessage>
    value: string
    sendMessage: (evt: any) => void
    handleChange: (evt: any) => void
}

const regexPattern = /^\s+/;

const truncateBlank: (m: string) => string = (message: string) => message.replace(regexPattern, '');

export default function ChatPanel({
                                      messages,
                                      value,
                                      sendMessage,
                                      handleChange,
                                  }: ChatPanelProps) {

    const {handleMute, disableChat, muteControl, muteChat} = useChatControl();

    const ref = useRef(null);

    const scrollDown = (current: any) => {
        current.scrollTop = current.scrollHeight;
    }

    const toTop = (current: any) => {
        current.scrollTop = 0;
    }

    useEffect(() => {
        let current:any = ref.current
        if(current.scrollTop + current.offsetHeight >= current.scrollHeight - 200){
            scrollDown(ref.current);
        }
    }, [messages]);

    const roomState = useRoomState();
    const [done, setDone] = useState(false);
    const [msgList, setMsgList] = useState([]);
    const [msgData, setMsgData] = useState({
        live_id: roomState.course.rid,
        channel: roomState.course.rid,
        lt_id: '',
        page: 1,
        limit: 20
    });


    const getMessageList = () => {
        sfAjax.get('expert/api.Expert/liveContentPageList', msgData).then((res: any) => {
            if (res.code == 1) {
                if (msgData.lt_id == '') {
                    setMsgList(res.data);
                    scrollDown(ref.current);
                } else if (msgData.lt_id) {
                    setMsgList(res.data.concat(msgList));
                    toTop(ref.current)
                }
                setMsgData({
                    ...msgData,
                    lt_id: res.data.length > 0 ? res.data[0].id : msgData.lt_id
                })
                if (res.data.length < msgData.limit) {
                    setDone(true)
                }
            } else {

            }
        }).catch(err => {

        })
    }
    useEffect(() => {
        getMessageList()
    }, [])

    return (
        <>
            <div className="chat-messages-container">
                {
                    done ? null
                        : <div className="tapMore" onClick={(evt: any) => {
                            getMessageList()
                        }}>点击查看更多信息</div>
                }
                <div className="chat-messages" ref={ref}>
                    {msgList.map((item: any, key: number) => (
                        <Message key={key} nickname={item.user_name} content={item.content} link={''}
                                 sender={item.m_id.toString() === roomState.me.uid}/>
                    ))}
                    {messages.map((item: ChatMessage, key: number) => (
                        <Message key={key} nickname={item.account} content={item.text} link={item.link}
                                 sender={item.id === roomState.me.uid}/>
                    ))}
                </div>
            </div>
            <div className="message-panel">
                {muteControl ?
                    <div className={`icon ${muteChat ? 'icon-chat-off' : 'icon-chat-on'}`}
                         onClick={() => {
                             handleMute(muteChat ? 'unmute' : 'mute')
                         }}></div> : null}
                <Input
                    disabled={disableChat}
                    value={value}
                    placeholder="发送信息"
                    disableUnderline
                    className={"message-input"}
                    onKeyPress={async (evt: any) => {
                        if (evt.key === 'Enter') {
                            const val = truncateBlank(value)
                            val.length > 0 && await sendMessage(val);
                        }
                    }}
                    onChange={handleChange}/>
                <Button className={'chat-panel-btn'} name={"发送"}
                        onClick={async (evt: any) => {
                            const val = truncateBlank(value)
                            val.length > 0 && await sendMessage(val);
                        }}/>
            </div>
        </>
    )
}
